<template>
  <div id="mobile-show" style="width: 100%;margin: 10px;overflow: hidden;">
    <div @click="toHome" style="display: flex;border: 1px solid #e0e0e0;position: absolute;border-radius: 15px;padding: 5px 10px;z-index: 999;align-items: center">
      <div style="padding-right: 5px;border-right: 1px solid #e0e0e0;"><i class="el-icon-s-home" style="font-size: 20px"></i></div>
      <div style="padding-left: 5px;font-size: smaller">
        返回首页
<!--        <i class="el-icon-refresh" style="font-size: 20px"></i>-->
      </div>
    </div>
    <div v-if="type === 'image'">
      <van-swipe :autoplay="3000" @change="onChange">
        <van-swipe-item v-for="(item,index) in imageList" :key="index" style="margin: 10px 10px;">
          <van-image
            :height="imageHeight"
            :width="imageWidth"
            fit="contain"
            :src="item.url"
            @click="toPreview(index)"
          />
        </van-swipe-item>
        <template #indicator>
          <div class="custom-indicator">{{ current + 1 }}/4</div>
        </template>
      </van-swipe>

      <van-image-preview v-model="previewShow" :images="urls" onClose="previewShow = false" :startPosition="imageIndex"></van-image-preview>
    </div>
    <div v-if="type === 'video' && showData['fileUrls']" style="height: 100%;display: flex;align-items: center">
      <video controls playsinline class="preview-video" width="100%" height="auto">
        <source :src="`${$config.upload_file_url}${showData.fileUrls[0]}`" />
      </video>
    </div>
  </div>
</template>

<script>
import { ImagePreview } from 'vant';
export default {
  name: 'mobile-show',
  components: {

  },
  data() {
    return {
      type: '',
      token: '',
      showHeight: '',
      imageHeight: '',
      current: 0,
      imageList: [],
      urls: [],
      previewShow: false,
      imageIndex: 0,
      isAdmin: 0,
      showData: {}
    }
  },
  mounted(){
    const height = window.screen.availHeight;
    const width = window.screen.availWidth;
    this.showHeight = ( height - 20 ) + "px";
    this.imageHeight = ( height - 60 ) + "px";
    this.imageWidth = ( width - 40 ) + "px"
    const path = window.location.href;
    const params = path.split('?')[1];
    let type = "";
    let token = "";
    let isAdmin = "";
    if(params){
      const temp = params.split('&');
      type = temp[0].split('=')[1];
      token = temp[1].split('=')[1];
      if(temp.length > 2){
        if(temp[2].split('=')[0] === 'id'){
          isAdmin = temp[2].split('=')[1];
        }
      }
    }
    this.type = type;
    this.token = token;
    this.isAdmin = isAdmin;

    this.getUploadList();
  },
  methods: {
    onChange(index) {
      this.current = index;
    },

    async getUploadList(){
      let a = false
      if(this.isAdmin == 1) a = true;
      const result = await this.$request.get_user_upload(this.token,a);
      //console.log(result);
      if(result.code === 0){
        if(this.type === 'image' || this.type === 'card'){
          let resList = result.data.uploads.fileUrls;
          let imageList = [];
          let urls = [];
          resList.forEach(fileName => {
            let temp = {
              fileName,
              url: this.$config.upload_file_url + fileName,
              type: 'image'
            }
            imageList.push(temp);
            urls.push(this.$config.upload_file_url + fileName)
          })
          this.imageList = imageList
          this.urls = urls;
          //ImagePreview(urls)
        }else if(this.type === 'video'){
          this.showData = result.data['uploads']
        }
      }
    },

    toPreview(index){
      this.previewShow = true;
      this.imageIndex = index;
    },

    toHome(){
      window.location.href = "https://www.suonida.com"
    },

  }
}
</script>

<style>
  .my-swipe .van-swipe-item {
    color: #fff;
    font-size: 20px;
    line-height: 150px;
    text-align: center;
    background-color: #39a9ed;
  }
.custom-indicator {
  position: absolute;
  right: 5px;
  bottom: 5px;
  padding: 2px 5px;
  font-size: 12px;
  background: rgba(0, 0, 0, 0.1);
}
</style>



// WEBPACK FOOTER //
// src/pages/mobile/MobileShow.vue